import React, { useState } from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import CustomInput from "../../../../Components/Common/CustomInput/CustomInput";
import CustomSelect from "../../../../Components/Common/CustomSelect/CustomSelect";
import districts from "../data/districtData";
import Select from "react-select";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";

const IndividualDefaulters = ({ formik }) => {
  const [selectOptions] = useState(districts);

  const handleSelectChange = (value) => {
    formik.setValues({
      ...formik.values,
      citizenshipIssueDistrict: value,
    });
  };

  const handleRadioChange = (value) => {
    formik.setValues({
      ...formik.values,
      reportingBasis: value,
    });
  };

  const handleDateChange = (value) => {
    formik.setValues({
      ...formik.values,
      loanMaturityDate: value,
    });
  };

  console.log("formik.values", formik.values);

  return (
    <div>
      <div className="mb-3">
        <CustomInput
          required
          label={"Name"}
          handleBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          id={"name"}
          name={"name"}
          placeholder={"Enter name"}
          value={formik.values.name}
          error={formik.errors.name}
          touched={formik.touched.name}
        />
      </div>
      <div className="mb-3">
        <CustomInput
          required
          label={"Address"}
          handleBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          id={"address"}
          name={"address"}
          placeholder={"Enter address"}
          value={formik.values.address}
          error={formik.errors.address}
          touched={formik.touched.address}
        />
      </div>
      <div className="mb-3">
        <CustomInput
          required
          label={"Citizenship Number"}
          handleBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          id={"citizenshipNumber"}
          name={"citizenshipNumber"}
          placeholder={"Enter citizenship number"}
          value={formik.values.citizenshipNumber}
          error={formik.errors.citizenshipNumber}
          touched={formik.touched.citizenshipNumber}
        />
      </div>
      <div className="mb-3">
        <CustomSelect
          required
          label={"Citizenship Issue District"}
          name={"citizenshipIssueDistrict"}
          id={"citizenshipIssueDistrict"}
          options={selectOptions}
          placeholder={"Enter citizenship issue district"}
          value={formik.values.citizenshipIssueDistrict}
          errors={formik.errors.citizenshipIssueDistrict}
          setFieldTouched={formik.setFieldTouched}
          setFieldValue={formik.setFieldValue}
          onChange={handleSelectChange}
        />
      </div>
      <div className="mb-3">
        <CustomInput
          // required
          label={"Spouse Full Name"}
          handleBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          id={"spouseFullName"}
          name={"spouseFullName"}
          placeholder={"Enter spouse's full name"}
          value={formik.values.spouseFullName}
          error={formik.errors.spouseFullName}
          touched={formik.touched.spouseFullName}
        />
      </div>
      <Row className="mt-4 bg-light py-2 mb-3">
        <Col xs={12} className="text-start">
          <span className="fw-bold px-3">Three Generation Details</span>
        </Col>
      </Row>
      <div className="mb-3">
        <CustomInput
          required
          label={"Father Full Name"}
          handleBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          id={"fathersFullName"}
          name={"fathersFullName"}
          placeholder={"Enter father's full name"}
          value={formik.values.fathersFullName}
          error={formik.errors.fathersFullName}
          touched={formik.touched.fathersFullName}
        />
      </div>
      <div className="mb-3">
        <CustomInput
          required
          label={"GrandFather Full Name"}
          handleBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          id={"grandfatherFullName"}
          name={"grandfatherFullName"}
          placeholder={"Enter grandfather's full name"}
          value={formik.values.grandfatherFullName}
          error={formik.errors.grandfatherFullName}
          touched={formik.touched.grandfatherFullName}
        />
      </div>
      <Row className="mt-4 bg-light py-2 mb-3">
        <Col xs={12} className="text-start">
          <span className="fw-bold px-3">Loan Details</span>
        </Col>
      </Row>
      <div className="mb-3">
        <CustomInput
          required
          label={"Loan Amount"}
          handleBlur={formik.handleBlur}
          handleChange={formik.handleChange}
          id={"loanAmount"}
          name={"loanAmount"}
          placeholder={"Enter loan amount"}
          value={formik.values.loanAmount}
          error={formik.errors.loanAmount}
          touched={formik.touched.loanAmount}
        />
      </div>
      <div className="mb-3">
        <Label for="loanMaturityDate">Loan Maturity Date</Label>
        <NepaliDatePicker
          inputClassName="form-control"
          className=""
          value={formik.values.loanMaturityDate || ""}
          onChange={handleDateChange}
          options={{ calenderLocale: "en", valueLocale: "en" }}
        />
        {formik.errors.loanMaturityDate && formik.touched.loanMaturityDate && (
          <div className="text-danger">{formik.errors.loanMaturityDate}</div>
        )}
      </div>
      <Row>
        <span className="mb-1 mt-2 fw-bold">Reporting on basis of</span>
        <Col xs={4}>
          <FormGroup check>
            <Input
              name="radio1"
              type="radio"
              checked={formik.values.reportingBasis === "DueIntrest"}
              onChange={() => handleRadioChange("DueIntrest")}
            />{" "}
            <Label check>Due Interest</Label>
          </FormGroup>
        </Col>
        <Col xs={4}>
          <FormGroup check>
            <Input
              name="radio2"
              type="radio"
              checked={formik.values.reportingBasis === "DueInstallment"}
              onChange={() => handleRadioChange("DueInstallment")}
            />{" "}
            <Label check>Due Installment</Label>
          </FormGroup>
        </Col>
        <Col xs={4}>
          <FormGroup check>
            <Input
              name="radio3"
              type="radio"
              checked={formik.values.reportingBasis === "LoanOverDue"}
              onChange={() => handleRadioChange("LoanOverDue")}
            />{" "}
            <Label check>Loan Overdue</Label>
          </FormGroup>
        </Col>
        {formik.errors.reportingBasis && formik.touched.reportingBasis && (
          <div className="text-danger">{formik.errors.reportingBasis}</div>
        )}
      </Row>
    </div>
  );
};

export default IndividualDefaulters;
